const SvgLemonadeGradient = (): JSX.Element => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ position: 'fixed', top: '100vh', zIndex: -1 }}>
			<defs>
				<linearGradient
					id="svg_lemonade_gradient"
					x1="0"
					y1="22"
					x2="12.0004"
					y2="1.99999"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFFD62" />
					<stop offset="1" stopColor="#FF6AE6" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SvgLemonadeGradient;